import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import i18n from '@/i18n'

Vue.use(VueRouter)

import routes from './routes';

const router = new VueRouter({
  mode: 'history',//hash for mobile app
  routes // you may use only 'routes' short for routes: routes
})

router.beforeEach((to, from, next) => {
  const defaultLocale = process.env.VUE_APP_I18N_LOCALE || 'en'
  i18n.locale = localStorage.getItem('app_lang') || defaultLocale
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (localStorage.getItem('token') == undefined || localStorage.getItem('token') == null) {
      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      });
    } else {
      next();
    }
  } else {
    next();
  } /*else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('jwt') == null) {
      next()
    } else {
      next({ name: 'userboard' })
    }
  } else {
    next()
  }*/
})


export default router
